import { Route, Routes } from 'react-router-dom';

import Nav from './routes/nav.route';
import Home from './routes/home.route';
import MainProjects from './routes/main-projects.route';
import BankingApp from './routes/banking-app.route';
import PersonalSite from './routes/personal-site.route';
import CrwnClothing from './routes/crwn-clothing.route';
import Projects from './routes/projects.route';
import About from './routes/about.route';
import Contact from './routes/contact.route';

import './app.scss'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Nav />}>
        <Route index element={<About />} />
      </Route>
      <Route path="/" element={<About />}/>
      <Route path="/" element={<Nav />}> 
        <Route path='projects' element={<MainProjects />}/>
        {/* <Route path='projects/banking-app' element={<BankingApp />}/>
        <Route path='projects/personal-site' element={<PersonalSite />}/>
        <Route path='projects/crwn-clothing' element={<CrwnClothing />}/> */}
        <Route path='all-projects' element={<Projects />}/>
        <Route path='about' element={ <About /> }/>
        <Route path='contact' element={<Contact />}/>   
      </Route>
    </Routes>
  );
}

export default App;
